var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "auth-shared-title logo-element div-logo-big" },
      [_c("div", [_c("h1", { staticClass: "logo-name" })])]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }